import { ParcelDto } from '@shared/types/parcel';
import { WeightDto } from '@shared/types/weight';

export interface BagDto {
  id: number;
  number: string | null;
  userName: string | null;
  parcelsCount: number;
  actualWeight: WeightDto;
  closedAt: Date | null;
  closedNumber: string | null;
  shippedAt: Date | null;
  createdAt: Date;
  bagCode: string;
  regionZone: string | null;
  chuteNumber: string | null;
  isPostal?: boolean;
  isReturn: boolean;
  type: ManifestBagType | null;
}

export interface FirstMileServicesRegion {
  id: string;
  name: string;
  regionZone: string;
}

export interface FirstMileServicesMarketplace {
  id: string;
  name: string;
}

export interface FirstMileServicesRoute {
  id: string;
  name: string;
  region: FirstMileServicesRegion;
  marketplace: FirstMileServicesMarketplace;
}

export interface FirstMileServicesResponse {
  routes: FirstMileServicesRoute[];
  marketplaces: FirstMileServicesMarketplace[];
}

export enum ManifestBagType {
  BoxM = 1,
  Bag = 2,
  BoxL = 3,
  BigBag = 4,
  LowDensityBag = 5,
  BagDG = 6,
  BigBagDG = 7,
}

export interface ICreateStateBag {
  regionZone: string;
  bagCode: string;
  type: ManifestBagType;
  isReturn: boolean;
}

export interface GetAllSortingBagCodes {
  items: GroupedBagCodesItem[];
}

export interface CreateBagProps {
  bagCodes: GroupedBagCodesItem[];
  isLoading: boolean;
  onRefetchTable?: () => Promise<void>;
  onChangeOpenModal: (isOpen: boolean) => void;
  isOpenModal: boolean;
}

export interface WeightType {
  weight: number;
  weightValue: string;
  parcelsCount?: number;
}

export interface ParcelItemsDto {
  items: ParcelDto[];
}

export enum AddParcelToBagStatus {
  Added,
  NotFound,
  Canceled,
  QualityControl,
  AlreadyInBag,
  BagAlreadySealed,
  NotScanned,
  UnMeetBagCode,
  PostalParcelWasNotLabeled,
  ReturnBagRequiresCanceledParcel = 9,
  /** Мешок достиг предела наполнения по весу — больше не кладём, нужно закрыть. */
  BagWeightLimitReached = 10,
}

export type GroupedBagCodesResponse = {
  items: GroupedBagCodesItem[];
};

export type GroupedBagCodesItem = {
  regionZone: string;
  bagCodes: BagCodeItem[];
};

export type BagCodeItem = {
  code: string;
  sortingCodes: string[];
};
